import { useMutation } from '@tanstack/react-query';
import { apiClient } from '../apiClient';
import { getQueryKeyBase, MUTATION_KEYS, queryClient } from '../queryClient';
import { updateCacheArray, CACHE_ACTIONS } from '../cacheClient';
import { getQueryKey as getQueryKeySecuritySchemes } from './useSecuritySchemes';
import { getQueryKey as getQueryKeySecuritySchemeById } from './useSecuritySchemeById';

// Config
import { uiConfig } from '../../../conf/securitySchemes';

export const getMutationKey = getQueryKeyBase.bind(null, MUTATION_KEYS.SECURITY_SCHEME);

export const useCreateScheme = ({ crudConfig, sessionToken, onSuccessCb, onErrorCb, onSettledCb }) => {
    const Client = apiClient(crudConfig);

    return useMutation({
        mutationKey: getMutationKey(),
        mutationFn: ({ newScheme }) => Client.insert(sessionToken, newScheme),
        onSuccess: (data, variables) => {
            updateCacheArray({
                queryKey: getQueryKeySecuritySchemes(),
                action: CACHE_ACTIONS.INSERT,
                primaryKey: uiConfig.primaryKey,
                data
            });
            queryClient.invalidateQueries({
                queryKey: getQueryKeySecuritySchemeById(data.schemeId)
            });
            onSuccessCb?.({ data: data.schemeId, context: variables?.context });
        },
        onError: (error) => {
            console.log('Error', error);
            onErrorCb?.(error);
        },
        onSettled: () => {
            onSettledCb?.();
        },
        refetchOnWindowFocus: false
    });
};
